module.exports = __webpack_public_path__ + "static/media/arrow-left.b5924719.svg";